import { useMemo } from 'react'
import { ReceptorUtilPromiseClient } from '@trustero/trustero-api-web/lib/receptorutil/receptorutil_grpc_web_pb'
import { GetGoogleDrivePickerConfigRequest } from '@trustero/trustero-api-web/lib/receptorutil/receptorutil_pb'
import { useSwrImmutableGrpc } from 'src/components/async/useSwrImmutableGrpc'

export type GoogleDrivePickerConfig = {
  /** Google OAuth web client ID the picker signs the browser user in with. */
  oauthClientId: string
  /** Optional Cloud project number for PickerBuilder.setAppId. */
  appId: string
  /** True until the first fetch settles; the picker should not open before then. */
  isLoading: boolean
}

const request = new GetGoogleDrivePickerConfigRequest()

/**
 * The OAuth client the picker needs lives in ntrced's configuration
 * (oauth_gdrive_client_id), the same client the Google Drive receptor's own
 * OAuth flow uses. Fetching it keeps one source of truth per environment
 * instead of a second copy in a frontend build-time variable.
 */
export const useGoogleDrivePickerConfig = (): GoogleDrivePickerConfig => {
  const { response } = useSwrImmutableGrpc(
    ReceptorUtilPromiseClient.prototype.getGoogleDrivePickerConfig,
    request,
  )
  const { data, error } = response

  return useMemo(
    () => ({
      oauthClientId: data?.getOauthClientId() || '',
      appId: data?.getAppId() || '',
      isLoading: !data && !error,
    }),
    [data, error],
  )
}
